import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import InstitutionIconsTemplate from './InstitutionIconsTemplate';

const SelectInstitutionTemplatePicker = ({
  className,
  resource,
}) => {
  return <InstitutionIconsTemplate className={className} resource={resource} />;
};

SelectInstitutionTemplatePicker.defaultProps = {
  className: '',
};

SelectInstitutionTemplatePicker.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default SelectInstitutionTemplatePicker;
